/**
 * Upsell add-to-cart handler.
 *
 * Loaded once at the page level (not inside the cart section), so this
 * delegated listener survives any number of morphSection / sectionRenderer
 * re-renders of the cart drawer without needing to re-register.
 */
document.addEventListener('click', async function (e) {
      const optionBtn = e.target.closest('.upsell-option-btn, .upsell-swatch');
    if (optionBtn) {
        const item = optionBtn.closest('.upsell-item');

        // Set active state
        const group = optionBtn.closest('.upsell-option-values');
        group.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        optionBtn.classList.add('active');

        // Collect selected options for this product
        const selectedOptions = [];
        item.querySelectorAll('.upsell-option').forEach(opt => {
        const active = opt.querySelector('.active');
        if (active) selectedOptions.push(active.dataset.value);
        });

        // Find matching variant
        const variants = JSON.parse(item.querySelector('.upsell-variants').textContent);
        const match = variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
        );

        if (match) {
        // Update Add button to correct variant ID
        const addBtn = item.querySelector('.upsell-add-btn');
        addBtn.dataset.variant = match.id;

        // Update price
        const priceEl = item.querySelector('.upsell-price');
        if (priceEl) priceEl.textContent = Shopify.formatMoney(match.price);
        }

        // Stop here if the click was just on the option (not Add button)
        return;
    }
  const target = e.target instanceof Element ? e.target.closest('.upsell-add-btn') : null;
  if (!(target instanceof HTMLElement)) return;
  const btn = target;

  e.preventDefault();

  const productId = btn.dataset.variant;
  if (!productId) return;

  btn.classList.add('loading');

  try {
    // Find the cart section ID so we can request section HTML inline.
    // This avoids the slow sectionRenderer.renderSection() round-trip that
    // would otherwise be triggered by dispatching cart:update with sections:{}.
    const cartItemsEl = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = cartItemsEl instanceof HTMLElement ? (cartItemsEl.dataset.sectionId ?? '') : '';

    // Add product to cart AND request the rendered section HTML in one call.
    // Shopify's /cart/add.js supports a `sections` param that returns
    // rendered section HTML alongside the cart data.
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: productId,
        quantity: 1,
        sections: sectionId,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }

    const data = await response.json();

    // Dispatch cart update event with the section HTML already included.
    // cart-items-component will call morphSection() directly instead of
    // triggering a slow extra fetch via sectionRenderer.renderSection().
    const cartUpdateEvent = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: data,
        sourceId: 'upsell-section',
        data: {
          source: 'upsell-section',
          itemCount: data.item_count ?? 0,
          sections: data.sections ?? {},
        },
      },
    });

    document.dispatchEvent(cartUpdateEvent);
  } catch (error) {
    console.error('Error adding to cart:', error);
  } finally {
    btn.classList.remove('loading');
  }
});
